<template>
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20 5.43284C11.9548 5.43284 5.43284 11.9548 5.43284 20C5.43284 28.0452 11.9548 34.5672 20 34.5672C28.0452 34.5672 34.5672 28.0452 34.5672 20C34.5672 11.9548 28.0452 5.43284 20 5.43284ZM4 20C4 11.1634 11.1634 4 20 4C28.8366 4 36 11.1634 36 20C36 28.8366 28.8366 36 20 36C11.1634 36 4 28.8366 4 20Z"
      class="fill-current"
    />
    <path d="M19 16H21V29H19V16Z" class="fill-current" />
    <path
      d="M21.5908 11.5C21.5908 12.3284 20.9192 13 20.0908 13C19.2624 13 18.5908 12.3284 18.5908 11.5C18.5908 10.6716 19.2624 10 20.0908 10C20.9192 10 21.5908 10.6716 21.5908 11.5Z"
      class="fill-current"
    />
  </svg>
</template>
